<template>
  <div class="all">
    <!-- header开始 -->
    <v-header></v-header>
    <!-- <div class="headercom">
    <div class="header-log">
      <img src="static/image/hengan_logo@3x.png" />
    </div>
    <div class="header-setting">
      <img src="static/image/header-bell.png" height="100%" />
      <span class="msgdot" v-show="reddot"></span>
    </div>
    <div class="header-bell">
      <img @click="dialogVisible = logOut" src="static/image/header-setting.png" height="100%" />
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" :append-to-body=true width="30%">
      <span>退出登录</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="notLogOut()">取 消</el-button>
        <el-button type="primary" @click="logOut()">确 定</el-button>
      </span>
    </el-dialog>
  </div> -->
    <!-- header结束 -->
    <!-- <div class="conH"></div> -->
    <div class="content">
      <div class="part-top">
        <div class="part-left">
          <!-- <img src="static/image/banner_home.png" /> -->
          <div class="block" style="height:100%;">
            <!-- <span class="demonstration">默认 Hover 指示器触发</span> -->
            <el-carousel  style="height:100%;overflow:hidden;">
              <el-carousel-item v-for="item in caros" :key="item.key">
                <!-- <h3 class="small">{{ item }}</h3> -->
                <img :src="item.name" />
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="part-right">
          <div class="datetime">
              <label>{{date}}</label>
              <span>{{day}}</span>
          </div>
          <div class="weather" >
            <!--  src="../assets/weatherIcon/W0.png" -->
              <div class="icon"><img :src="weatherIcon"></div>
              <div class="txt">
                <div class="">{{weatherToday.conditionDay}}</div>
                <div class="" v-if="weatherToday.tempDay">{{weatherToday.tempNight}}-{{weatherToday.tempDay}}°</div>
              </div>
          </div>
          <div class="location" v-if="userLocation">
            <div>{{userLocation}}</div>
            
          </div>
          <div class="temperature" v-if="weatherToday.windLevelDay">
            <div class="tempval">{{weatherToday.windDirDay}} {{weatherToday.windLevelDay}}级</div>
            <div class="temptxt">风向等级</div>
          </div>
        </div>
      </div>
      <div class="part1-top">
        <div class="part0-left">
          <div class="part1-left">
          <span class="part-title part-title2">快捷入口</span>
          <ul class="tubiao">
            <li v-if="index<11" v-for="(item, index) in result" :key="index" @click="toURLParameter(item.url)">
              <div class="liimg"><img :src="item.imUrl"></div>
              <span>{{item.privName}}</span>
            </li>
            <li v-if="showStatus>11" @click="toURLParameter('home/shortcutMenu')">
              <div class="liimg"><img src="static/iamges/index/all_Quick_icon_home@3x.png"></div>
              <span>全部</span>
            </li>
          </ul>
        </div>
        <!-- <div class="part1-middle">
          <i class="el-icon-back icon-nextmore"></i>
          <p class="part-title">培训资料</p>
          <div class="swiper-container">
              <div class="swiper-container-con">
                <div class="swiper-wrapper">
                    <div class="swiper-slide"><img src="static/image/book_blue.png" /></div>
                    <div class="swiper-slide"><img src="static/image/book_blue.png" /></div>
                    <div class="swiper-slide"><img src="static/image/book_blue.png" /></div>
                </div>             
              <div class="swiper-pagination"></div>
              </div>             
          </div>
        </div> -->

        </div>

        <div class="part1-right">
          <i class="el-icon-right icon-nextmore" @click="popTips()"></i>
          <p class="part-title">活动量</p>
          <!-- 日期组件 2019.1.4 wrj -->
          <div class="calendarBoxCon">
            <!-- <Calendar class="calendarBox"
              v-on:choseDay="clickDay"
              v-on:changeMonth="changeDate"
              v-on:isToday="clickToday"
              ref="Calendar"
            ></Calendar> -->
            <Calendar
                ref="calendar1"
                :events="calendar1.events"
                :lunar="calendar1.lunar"
                :value="calendar1.value"
                :values="calendar1.values"
                :weeks="calendar1.weeks"
                :months="calendar1.months"
                :totalMonth="calendar1.totalMonth"
                @selectMonth="calendar1.selectMonth"
                @selectYear="calendar1.selectYear"               
            ></Calendar>
          </div>

        </div>
      </div>
      <div class="part-bottom">
        <div class="bottom-left">
          <i class="el-icon-right icon-nextmore" @click="toURLParameter(proUrl)"></i>
          <p class="part-title part-title1">人气产品</p>
          <!-- <div class="chanpin"> <img src="static/image/linshi.png" /></div> -->
          <div class="chanpin">
            <el-row :gutter="25" type="flex" class="row-box" justify="space-between">
              <el-col :span="8" class="col-box" v-for="(item,index) in products" :key="item.key" v-if="index<3">
                  <div v-if="item.imgUrl" class="nodataCon"><img  src="static/image/index/jqqd.png" class="nodata"></div>
                  <div v-else class="prolist-one" @click="toURLParameter(item.pageUrl)">
                    <div class="imgbox"><img :src="item.picUrl"></div>
                    <div class="subject">{{item.title}}
                      <!-- <span>分红型</span> -->
                      </div>
                    <div class="info">{{item.prodIntroducton}}</div>
                    <div class="tag"><span v-for="(subitem,subindex) in item.keywords" :key="subitem.key" v-if="subindex<1">{{subitem}}</span></div>
                  </div>
              </el-col>
              <!-- <el-col :span="8" class="col-box">
                  <div class="prolist-one">
                    <div class="imgbox"><img src="static/image/production1_home.png"></div>
                    <div class="subject">恒久之爱 睿智之选<span>分红型</span></div>
                    <div class="info">恒安标准恒爱睿赢终身年金保险</div>
                    <div class="tag"><span>保证领</span><span>终身领</span></div>
                  </div>
              </el-col>
              <el-col :span="8" class="col-box">
                  <div class="prolist-one">
                    <div class="imgbox"><img src="static/image/production2_home.png"></div>
                    <div class="subject">恒久之爱 睿智之选<span>分红型</span></div>
                    <div class="info">恒安标准恒爱睿赢终身年金保险</div>
                    <div class="tag"><span>保证领</span><span>终身领</span></div>
                  </div>
              </el-col>
              <el-col :span="8" class="col-box">
                  <div class="prolist-one">
                    <div class="imgbox"><img src="static/image/production3_home.png"></div>
                    <div class="subject">恒久之爱 睿智之选<span>分红型</span></div>
                    <div class="info">恒安标准恒爱睿赢终身年金保险</div>
                    <div class="tag"><span>保证领</span><span>终身领</span></div>
                  </div>
              </el-col> -->
            </el-row>
          </div>

        </div>
        <div class="bottom-right0">
          <div class="bottom-middle">
            <i class="el-icon-right icon-nextmore" @click="popTips()"></i>
            <p class="part-title part-title1">电子杂志</p>
            <div class="zazhi" @click="popTips()">
              <img :src="zazhiimg" />
              <!-- <img src="static/image/magazine_home.png" />
              <div class="data-title">创营赢快讯第37期<br>（总491期）</div> -->
            </div>
          </div>
          <div class="bottom-right">
            <i class="el-icon-right icon-nextmore" @click="toURLParameter(honourUrl)"></i>
            <p class="part-title part-title1">荣誉殿堂</p>
            <div class="honour" @click="toURLParameter(honourUrl)">
                <div class="data-border">
                  <img :src="honourimg">
                <!-- <div class="jiangxiang"> <img src="static/image/glory1_home.png" /></div>
                <div class="jiangxiang"> <img src="static/image/glory2_home.png" /></div> -->
              </div>
            </div>
          </div>
        <div class="clear"></div>
        </div>
        <div class="clear"></div>

      </div>
      <v-footer></v-footer>
    </div>
    
  </div>

</template>
<script>
// 引入api模块
import api from '@/modules/api.js'
// import Calendar from 'vue-calendar-component'
import Calendar from '@/layout/calendar.vue'
import Swiper from 'swiper'
import vHeader from '@/layout/Header.vue'
import vFooter from '@/layout/Footer.vue'
// import http from '@/components/utils/axiost'
export default {
  // name: '首页',
  components: {
    Calendar, vHeader, vFooter
  },
  data () {
    return {
      result: '',
      showStatus: '',
      password: '',
      username: '',
      homePage: '',
      day: '',
      date: '',
      user: {
        manageCom: '1111', // 代理人的机构
        businessNo: '', // 代理人业务编码
        invalidator: '',
        agentCode: '' // 在登录会后存
      },
      dialogVisible: false,
      reddot: false, // header铃铛上面的红点
      arr: [{date: '2019/1/1', className: 'mark1'}, {date: '2019/1/13', className: 'mark2'}],
      products:[],
      imgH:'',
      userLocation:'',
      caros:[],
      trains:[],
      proUrl:'',
      zazhiimg:'',
      activityUrl:'',
      honourimg:'',
      honourUrl:'',
      calendar1:{
        totalMonth:1,   //一共显示几个月
        value:[], //默认日期  如果没设置就默认选中今天
        values:[[2019,4,1],[2019,4,19],[2018,6,6],[2018,7,11],[2018,8,11],[2018,8,12],[2018,8,14]], //有哪些时间点是被选中的
        lunar:true, //显示农历
//              weeks:['Sun', 'Mon' , 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
//              months:['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        events:{
            '2017-7-7':'$408',
            '2017-7-20':'$408',
            '2017-7-21':'$460',
            '2017-7-22':'$500',
        },
        select(value){
            console.log('ri',value.toString());
        },
        selectMonth(month,year){
            console.log(year,month)
        },
        selectYear(year){
            console.log(year)
        },
        timestamp:Date.now()
      },
      zazhiTips:false,
      weatherToday:[],
      weatherIcon:''
    }
  },
  computed: {},
  methods: {
    // check () {
    //   let that = this
    //   // todo... 1.验证监考人与代理人的机构是否属于同一机构 2.成功-添加24小时时效的验证跳转页面，失败-返回失败
    //   //      this.user.businessNo = session.session_get('businessNo')
    //   console.log(this.user.businessNo)
    //   api.invalidatorCheck(this.user, function (res) {
    //     console.log(res)
    //     if (res.data !== null) {
    //       that.user.manageCom = res.data
    //       //          session.session_set('businessNo', res.data)
    //       //          // that.show = true
    //       //          that.$router.push({name: 'ExamTypeList'})
    //     } else {
    //       that.$toast('考生与监考人员需在同一分公司')
    //     }
    //   })
    // },
    notLogOut () {
      this.dialogVisible = false
      this.$message({
        type: 'info',
        message: '取消退出'
      })
    },
    logOut () {
      // let submitInfo = { jwt: 'Basic ' + sessionstorage.session_get('token') }
      // let that = this
      // // 调用接口保存告知数据
      // api.logout(submitInfo, function (res) {
      //   if (res.result.isSuccess === true) {
      //     that.dialogVisible = false
      //     that.$message({
      //       type: 'success',
      //       message: '退出成功'
      //     })
      //     // that.$app.NaviInit.logOut()
      //     // sessionstorage.session_remove('token')
      //   } else {
      //     that.$message({
      //       type: 'info',
      //       message: '退出失败'
      //     })
      //   }
      // })
      // 删除cookie中jtl
      var keys = document.cookie.match(/[^ =;]+(?=\\=)/g)
      if (keys) {
        for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
      this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]

      // window.location.href = 'https://testsso.ihasl.com/HASLSSO2/logout?service=' + encodeURIComponent(this.homePage + '/pages/salessupport/pc/index.html#/')
      window.location.href = this.$logOutBack + encodeURIComponent(this.homePage + this.$address)
      // window.location.href = 'https://testsso.ihasl.com/HASLSSO2/logout?service=test.ihasl.com'
    },
    getMenuInfo () {
      let submitInfo = {
        pid: '47c71b6e0dea4a5f8fa9331dc53538bb'
      }
      let that = this
      // 调用接口保存告知数据
      api.getMenuInfo(submitInfo, function (res) {
        if (res.result.isSuccess === true) {
          that.result = res.data.menus.children
          console.log(that.result)
          console.log(that.showStatus)
          let arr=that.result
          console.log(arr,'菜单')
          let newArr = []
          for (var i = 0; i < arr.length; i++) {
            // newArr.push(arr[i])
            if (arr[i].privName !== '人气产品' && arr[i].privName !== '电子杂志' && arr[i].privName !== '活动量'  && arr[i].privName !== '荣耀殿堂' && arr[i].privName !== '培训资料') {
                newArr.push(arr[i])                                
            }

            if(arr[i].privName=='人气产品'){
              that.proUrl = arr[i].url
            }
            if(arr[i].privName=='电子杂志'){
              that.zazhiimg = arr[i].imUrl
            }
            if(arr[i].privName=='活动量'){
              that.activityUrl = arr[i].url
            }
            if(arr[i].privName=='荣耀殿堂'){
              that.honourUrl = arr[i].url
              that.honourimg = arr[i].imUrl
            }
            
          }
          that.result = newArr
          that.showStatus = that.result.length
        } else {
          that.$toast(res.result.error)
        }
      })
    },
    timer () {
      let _this = this
      let minti = new Date().getMinutes()
      if (minti < 10) {
        minti = 0 + '' + minti
      }
      _this.date = new Date().getHours() + ':' + minti
      let y = new Date().getFullYear()
      let m = new Date().getMonth()+1
      let d = new Date().getDate()
      _this.day =y + '年' + m + '月' + d +'日'
    },
    clickDay (data) {
      console.log(data) // 选中某天
    },
    changeDate (data) {
      console.log(data) // 左右点击切换月份
    },
    clickToday (data) {
      console.log(data) // 跳到了本月
    },
    getHotProductAndHeadline(){
      let that = this
      api.post(that.$url.getHotProductAndHeadline, {}, function (res) {
          if (res.result.isSuccess === true) {
              that.products = res.data.products
              // for(var i=0;i<that.products.length;i++){
              //     // console.log(that.products[i].keywords,"1111111")
              //     that.products[i].keywords = that.products[i].keywords.split(',')                  
              // }
              for(var j=0;j<=3;j++){
                  if(that.products.length<3){
                      let img = { imgUrl: "static/image/index/jqqd.png"};
                      that.products.push(img)
                  }
              }
              that.caros = res.data.caros
              // that.trains = res.data.trains
              
          } else {
              that.$toast(res.result.error)
          }
      })
    },
    toURLParameter(url){
      let that = this
      if (url === '') {
          that.$message('敬请期待')
      } else {
          if (url.slice(0, 4) === 'http') {
            // tempurl = url
            // window.location.href = tempurl
            window.open(url)
          }  else {
            if(url.slice(0, 1) === '/')
            {
              that.$router.push({path: url})
            }else{
              that.$router.push({path:'/' + url})
            }           
          }
      }
    },
    swiperBox(){
      // swiper 首页切换
      new Swiper('.swiper-container-con', {
        loop: true,
        slidesPerView: 2,
        spaceBetween: '8%',
        centeredSlides: true,
        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
        // 如果需要前进后退按钮
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
      })
    },
    // 初始化日历
    initCalendar() {
        // this.user.agentCode = session.session_get('agentId')
        let that = this
        api.post(that.$url.initCalendar,{},(res)=>{
            if(res.result.isSuccess) {
                let arr = []
                res.data.forEach( unit => {
                    let signYear = new Date(unit).getFullYear()
                    let signMonth = new Date(unit).getMonth()+1
                    let signDay = new Date(unit).getDate()
                    arr.push([signYear,signMonth,signDay])
                })
                that.calendar1.values = arr
                // loading.close()
            } else {
                this.$message({
                    message: '出错了',
                    type: 'warning'
                })
            }
        })
        this.dataFont = new Date().getMonth() + 1 + '月' + new Date().getDate() + '日'
    },
     popTips() {
      //  alert(1)
      //  this.zazhiTips = ture
        this.$alert('请到便携式设备端查看', '提示', {
          confirmButtonText: '确定',
          // callback: action => {
          //   this.$message({
          //     type: 'info',
          //     message: `action: ${ action }`
          //   });
          // }
        });
      },
      getWeather(){
        let that = this
        let userCitylng = window.localStorage.getItem('userCitylng')
        let userCitylat = window.localStorage.getItem('userCitylat')
        // let userLocation = window.localStorage.getItem('userLocation')
        let params = {
              "lat":userCitylat,
              "lon":userCitylng,
              "address":that.userLocation
        }
        api.post(that.$url.getWeather,params,(res)=>{
          if(res.result.isSuccess){
            // console.log(res.data,"==========")
            let jsonstr = JSON.parse(res.data)
            console.log(jsonstr,"------")
            that.weatherToday = jsonstr.data.forecast[0]
            // console.log(that.weatherToday.length,"lasjfdksj")
            let Icon = jsonstr.data.forecast[0].conditionIdDay
            that.weatherIcon = require("../assets/weatherIcon/W" + Icon + ".png")
          }

        })

      }
    
  },
  mounted () {
    // this.$app.NaviInit.init('入司考试')
    this.getMenuInfo()
    this.timer()
    this.getHotProductAndHeadline()
    // this.imgH = document.querySelector('.part-right').clientHeight + 'px'
    // setTimeout(function () {
    //     window.onresize = function () {
    //       this.imgH = document.querySelector('.part-right').clientHeight + 'px'
    //     }
    //   }, 100)
      // alert(this.imgH)
    this.userLocation= window.localStorage.getItem('userLocation')
    this.initCalendar()
    this.getWeather()
    // let str = '\u5929\u6d25'
    // alert(unescape(str.replace(/\\u/g, '%u')))
  }
  // ,
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     // 参数vm就是当前组件的实例。
  //     vm.check()
  //   })
  // }
}
</script>
<style scoped>

.all {
  width: 100%;
  /* height: 96%; */
  height: 100%;
  /* height: 614px; */
  background: rgba(245, 246, 250, 1);
  box-sizing: border-box;
}
ul,
li {
  list-style: none;
}
.content {
  width: 94%;
  /* height: 95%; */
  height: calc(100% - 60px);
  margin: 0 auto;
  padding-top: 2%;
  box-sizing: border-box;
  overflow: auto;
}
.content::-webkit-scrollbar{width:0;}
.part-top {
  width: 100%;
  height: 30%;
}
.part-left {
  width: 59%;
  height: 100%;
  /* display: inline-block; */
  float: left;
}
.part-left img {
  width: 100%;
  min-height: 100%;
}
.part-left >>> .el-carousel__container{height: 100%;}
.part-right {
  /* display: inline-block; */
  /* margin-left: 2.5%; */
  width: 39%;
  height: 100%;
  background: #fff;
  position: relative;
  float: right;
}
.datetime{
  position: absolute;
  left:15%;
  top: 10%;
}
.datetime label {
  display: block;
  font-size: 40px;
  letter-spacing: 2px;
  /* margin: 5% 0 0 5%; */
}
.datetime span {
  display: block;
  /* margin-top: 5px; */
  /* letter-spacing: 1px; */
  /* margin-left: 5%; */
}
.weather{
  position: absolute;
  left:14%;
  bottom: 12%;
  display: flex;
  /* flex-direction: column;
  justify-content:center;*/
  align-items: center;
}
.weather .icon{
  width: 44%;
  min-width: 60px;
}
.weather .icon img{
  display: block;
  width:85%;
   /* box-shadow: 3px 3px 4px #000; */
  /* filter: drop-shadow(0 0 1px #F9F8F8) drop-shadow(0 0 5px #FFFFFF) drop-shadow(0 0 1px #FFFFFF);
  -webkit-filter: drop-shadow(0 0 1px #F9F8F8) drop-shadow(0 0 5px #FFFFFF) drop-shadow(0 0 1px #FFFFFF); */
}
.weather .txt{
  font-size:17px;
  font-weight: bold;
  color:#C5A86E;
  text-align:center;
  line-height: 24px;
}
.location{
  position: absolute;
  right:18%;
  top:15%;
  text-align: center;
  font-size: 16px;
}
.location div{
  background:#5FAEFA;
  color:#fff;
  padding:5px 25px;
  border-radius: 5px;
}
.temperature{
  /* margin-top:65%;
  text-align: center;   */
  position: absolute;
  right:20%;
  bottom:14%;
  text-align: center;
  color: #C5A86E;
}
.tempval{
  font-size: 17px;
  font-weight: bold;
}
.temptxt{
  font-size: 16px;
  /* color: #9E9FA0; */
}
.part0-left{
  width:59%;
  float: left;
  height: 100%;
}
.part1-left {
  /* width: 69%; */
  width: 100%;
  display: inline-block;
  height: 100%;
  background: #fff;
  vertical-align: top;
}
.part-title {
  color: #002c76;
  font-size: 18px;
  margin: 10px 20px 10px 20px;
  display: inline-block;
  font-weight: bold;
}
.part1-top {
  width: 100%;
  height: 30%;
  clear: both;
  padding-top: 1%;
  box-sizing: border-box;
}
.tubiao {
  height: calc(100% - 34px);
  padding: 0;
  margin: 0;
}
.tubiao li {
  float: left;
  /* width: 25%; */
  width: 16.5%;
  text-align: center;
  height: 45%;
  padding-top: 2%;
  box-sizing: border-box;
}
.tubiao li span {
  display: block;
  color: #194793;
  font-size: 12px;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.part1-middle {
  width: 27.5%;
  height: 100%;
  /* margin-left: 2%; */
  background: #fff;
  /* display: inline-block; */
  float: right;
  position: relative;
}
.icon-nextmore{
  /* transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -o-transform: rotate(180deg); */
  position: absolute;
  right: 20px;
  top: 10px;
  color: #5FAEFA;
  font-size: 22px;
  cursor: pointer;
  z-index: 99;
}
.part1-middle img {
  height: 100%;
  width: 100%;
  display: block;
  margin: 0 auto;
}
.part1-right {
  width: 39%;
  /* margin-left: 2.1%; */
  height: 100%;
  background: #fff;
  /* display: inline-block; */
  vertical-align: top;
  position:relative;
  float: right;
}
.part-bottom {
  width: 100%;
  /* min-height: 30%;
  height: auto; */
  /* height: 45%; */
  height: 34%;
  padding-top: 1%;
  /* margin-bottom: 10px; */
  clear: both;
  box-sizing: border-box;
}
.bottom-left {
  width: 59%;
  height: 100%;
  /* display: inline-block; */
  vertical-align: top;
  float: left;
  position: relative;
}
.bottom-right0{
  /* margin-left: 2.5%; */
  width: 39%;
  height: 100%;
  /* display: inline-block; */
  float: right;
}
.bottom-middle {
  /* display: inline-block; */
  /* width: 17%; */
  width: 48%;
  height: 100%;
  float: left;
  /* margin-left: 1.2%; */
  vertical-align: top;
  position: relative;
}
.bottom-right {
  /* display: inline-block; */
  /* width: 18.5%; */
  float: right;
  width: 48%;
  height: 100%;
  /* margin-left: 1.5%; */
  vertical-align: top;
  position: relative;
}
.liimg {
  width: 32%;
  /* height: 52%; */
  height: 50%;
  margin: 0 auto;
}
.liimg img {
  height: 100%;
}
.zazhi {
  width: 100%;
  /* height: 100%; */
  height: calc(100% - 44px);
  cursor: pointer;
}
.zazhi img {
  width: 100%;
  height: 100%;
}
.honour{
  width: 100%;
  /* height: 100%; */
  height: calc(100% - 44px);
  padding:5%;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
}
.honour img{
  width: 100%;
  height: 100%;
}
.jiangxiang {
  width: 88%;
  height: 36%;
  margin: 0 auto;
  margin-top: 5%;
}
.jiangxiang img {
  width: 100%;
  /* height: 100%; */
}

.chanpin {
  width: 100%;
  /* height: 96%; */
  height: calc(100% - 44px);
}
.chanpin img {
  width: 100%;
}
.row-box,.col-box{height:100%;}
.prolist-one{cursor:pointer;height: 100%;}
.imgbox{ 
  /* min-height: 132px;
  max-height: 221px; */
  height: 58%;
  overflow: hidden;
}
.imgbox img{width: 100%;min-height:100%;}
.chanpin .subject{
  color:#002C76;
  font-size: 15px;
  font-weight: bold;
  line-height: 26px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chanpin .subject span{
  background:#FF6969;
  padding: 1px 8px;
  margin-left: 5px;
  border-radius: 3px;
  color: #fff;
  font-size: 12px;
}
.chanpin .info{
  font-size: 14px;
  color: #9E9FA0;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap
}
.chanpin .tag{
  margin-top: 2%;
  /* margin-bottom: 10px; */
}
.chanpin .tag span{
  border: 1px solid #18C29C;
  border-radius: 3px;
  padding: 1px 5px;
  color: #18C29C;
  margin-right: 5px;
  font-size: 12px;
  max-width: 73%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.part-title1 {
  /* margin-top: 0 !important; */
  margin-left: 0 !important;
}
.part-title2 {
  margin-bottom: 0 !important;
}
.data-title {
  height: 30%;
  text-align: center;
  color: #c6a970;
  background-color: #fff;
  font-size: 14px;
  line-height: 20px;
  padding-top: 10%;
  padding-bottom: 10%;
  margin-top: -3%;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.data-border {
  border: 1px solid #ccc;
  height: 100%;  
  box-sizing: border-box;
}
.data-color{
  background-color: #fff;
  padding: 5%;
}

/* 切换样式 */
.swiper-container {
    width: 100%;
    height: 78%;
    margin-top: 4%;
    /* margin: 0 auto; */
    /* margin: 20px auto; */
}
.swiper-container-con{height: 82%;}
.swiper-button-prev, .swiper-button-next{
  width:16px;
  height:26px;
  margin-top: -13px;
  background-size: 16px 26px;
}

.part1-middle >>> .swiper-pagination-bullet{
  width: 15%;
  height: 4px;
  border-radius: 25px;
}
.part1-middle >>> .swiper-pagination-bullet-active{
  background: #C6A970;
}
/* 人气产品敬请期待 */
.nodataCon{ 
  background: #fff;
  width:100%;
  height: 100%;
}
.chanpin img.nodata{
  width: 70%;
  height:auto;
  display: block;
  margin: 0 auto;
  padding-top: 12%;
}
/*活动量日历*/
.calendarBoxCon{width:100%;position: absolute;top: 0px;height:100% ;}
.calendarBoxCon >>> .calendar{background: transparent;height: 100%;}
.calendarBoxCon >>> .calendar-info>div.month .leftArrow{display:none;}
.calendarBoxCon >>> .calendar-info>div.month .rightArrow{display:none;}
.calendarBoxCon >>> .calendar-info{ margin: 0 auto;}
.calendarBoxCon >>> .calendar-tools{ border-bottom: 0;}
.calendarBoxCon >>> .calendar-info>div.month{margin-left: 0;width:50px;}
.calendarBoxCon >>> .calendar-info>div.month .month-inner{left:0;}
.calendarBoxCon >>> .swiper-container{height: 100%;}
.calendarBoxCon >>> .calendar .swiper-wrapper{height:calc(100% - 70px);overflow-y: auto;-webkit-overflow-scrolling: touch;}
.calendarBoxCon >>> .calendar .swiper-wrapper td{height: 60px;}
.calendarBoxCon >>> .calendar td .point{top:50px;}
.calendarBoxCon >>> .calendar .swiper-wrapper::-webkit-scrollbar {width:2px;height:10px;}
.calendarBoxCon >>> .calendar .swiper-wrapper::-webkit-scrollbar-thumb {
background:rgba(193,193,193, .5);
/* background-clip:padding-box; */
min-height:28px;
}
.calendarBoxCon >>> .calendar .swiper-wrapper::-webkit-scrollbar-thumb:hover {
background-color:#bbb;
}
/* 滚动条凹槽的颜色，还可以设置边框属性 */
/* .calendarBoxCon >>> .calendar .swiper-wrapper::-webkit-scrollbar-track-piece { 
background-color:#f8f8f8;
} */
/* .calendarBoxCon{position: absolute;top: 6px;height:calc(100% - 6px) ;}
.calendarBoxCon >>> .wh_container{max-width:100%;height: 100%;overflow: hidden;}
.calendarBoxCon >>> .wh_content{padding:0;}
.calendarBoxCon >>> .wh_content:last-child{height:140px; overflow-y:auto; }
.calendarBoxCon >>> .wh_content_all{background:transparent;height: 100%; }
.calendarBoxCon >>> .wh_top_changge li{color:#111;height: 40px;font-size: 16px;}
.calendarBoxCon >>> .wh_top_changge li:first-child{display:none;}
.calendarBoxCon >>> .wh_top_changge li:last-child{display:none;}
.calendarBoxCon >>> .wh_jiantou1{width: 7px;height: 7px;border-top: 2px solid #111;border-left: 2px solid #111;}
.calendarBoxCon >>> .wh_jiantou2{width: 7px;height: 7px;border-top: 2px solid #111;border-right: 2px solid #111;}
.calendarBoxCon >>> .wh_content_item{color:#111;}
.calendarBoxCon >>> .wh_top_changge{width: 65%;margin: auto;}
.calendarBoxCon >>> .wh_content_item .wh_isToday{background: #5FAEFA;border-radius: 5px;color:#fff;}
.calendarBoxCon >>> .wh_item_date:hover{border-radius: 5px;color:#fff;}
.calendarBoxCon >>> .wh_content_item .wh_chose_day{background: #71c7a5;border-radius: 5px;color:#fff;} */

/* .calendarBoxCon >>> .wh_content_item{ height: 30px;}
.calendarBoxCon >>> .wh_item_date{width:30px; height: 30px;line-height: 30px;} */

@media screen and (max-width: 1200px) {
  .datetime{left:12%;}
  .weather{left:11%;}
  .location{right:12%;}
  .temperature{right:14%;}
}
@media screen and (min-width: 1600px) {
  .datetime{left:17%;}
  .weather{left:16%;}
  .location{right:16%;}
  .temperature{right:18%;}
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue